/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Debtor information in a payment breakdown
 * @export
 * @interface BreakdownDebtorDto
 */
export interface BreakdownDebtorDto {
    /**
     * 
     * @type {string}
     * @memberof BreakdownDebtorDto
     */
    personId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BreakdownDebtorDto
     */
    legalEntityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BreakdownDebtorDto
     */
    naturalPersonId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BreakdownDebtorDto
     */
    designation: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownDebtorDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the BreakdownDebtorDto interface.
 */
export function instanceOfBreakdownDebtorDto(value: object): value is BreakdownDebtorDto {
    if (!('designation' in value) || value['designation'] === undefined) return false;
    return true;
}

export function BreakdownDebtorDtoFromJSON(json: any): BreakdownDebtorDto {
    return BreakdownDebtorDtoFromJSONTyped(json, false);
}

export function BreakdownDebtorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownDebtorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'] == null ? undefined : json['personId'],
        'legalEntityId': json['legalEntityId'] == null ? undefined : json['legalEntityId'],
        'naturalPersonId': json['naturalPersonId'] == null ? undefined : json['naturalPersonId'],
        'designation': json['designation'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function BreakdownDebtorDtoToJSON(json: any): BreakdownDebtorDto {
    return BreakdownDebtorDtoToJSONTyped(json, false);
}

export function BreakdownDebtorDtoToJSONTyped(value?: BreakdownDebtorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'legalEntityId': value['legalEntityId'],
        'naturalPersonId': value['naturalPersonId'],
        'designation': value['designation'],
        'email': value['email'],
    };
}

